import { cn } from '@/utils';

interface StepperProps {
  steps: number;
  currentStep: number;
  className?: string;
}

export const Stepper = ({ steps, currentStep, className }: StepperProps) => {
  return (
    <div className={cn('flex w-full items-center gap-2', className)}>
      {Array.from({ length: steps }).map((_, idx) => {
        const stepKey = `step-${steps}-${idx}`;
        return (
          <div
            key={stepKey}
            data-testid='step-bar'
            className={cn('h-1.5 flex-1 rounded-full transition-colors', idx <= currentStep ? 'bg-fill-button-primary-default' : 'bg-fill-background-medium')}
          />
        );
      })}
      <span className='sr-only'>
        {currentStep + 1} of {steps}
      </span>
    </div>
  );
};
